export const setupDropdowns = async (form) => {
  const dropdowns = form.querySelectorAll(".js-dropdown, .userform .field.dropdown");

  if (!dropdowns.length) {
    return;
  }

  const { default: easydropdown } = await import("easydropdown-a11y");

  dropdowns.forEach((el) => {
    const select = el.querySelector("select");

    if (!select) {
      return;
    }

    if (select.closest(".edd-root")) {
      return;
    }

    const placeholder = el.querySelector('option[value=""]');

    if (placeholder && !placeholder.hasAttribute("data-placeholder")) {
      placeholder.setAttribute("data-placeholder", true);

      if (!placeholder.textContent) {
        placeholder.textContent = "Select One";
      }
    }

    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 8,
        liveUpdates: true,
        useNativeUiOnMobile: false,
      },
    };

    easydropdown(select, opts);
  });
};

const setupMasks = async (form) => {
  const fields = form.querySelectorAll(
    'input[type="tel"], input[data-mask-currency], input[data-mask-num-range], input.as-date',
  );

  if (!fields.length) {
    return;
  }

  const { default: IMask } = await import("imask/esm/imask");
  await import("imask/esm/masked/date");
  await import("imask/esm/masked/number");
  await import("imask/esm/masked/pattern");

  fields.forEach((field) => {
    if (field.type === "tel") {
      IMask(field, {
        mask: "(000) 000-0000",
      });
    }

    if (field.dataset.maskCurrency !== undefined) {
      const mask = IMask(field, {
        mask: Number,
        scale: 0,
        thousandsSeparator: ",",
        min: 1,
      });

      field.addEventListener("updateValue", (e) => {
        field.value = e.detail;
        mask.updateValue();
        field.dispatchEvent(new Event("blur"));
      });
    }

    if (field.dataset.maskNumRange !== undefined) {
      const mask = IMask(field, {
        mask: /^(\d+)?(-)?(\d+)?$/,
      });

      field.addEventListener("updateValue", (e) => {
        field.value = e.detail;
        mask.updateValue();
        field.dispatchEvent(new Event("blur"));
      });
    }

    if (field.classList.contains("as-date")) {
      const pattern = "MM/DD/YYYY";

      const mask = IMask(field, {
        mask: Date,
        pattern: pattern,
        min: new Date(1920, 0, 1),
        max: new Date(),
        autofix: true,
        overwrite: true,
        blocks: {
          MM: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            placeholderChar: "M",
          },
          DD: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            placeholderChar: "D",
          },
          YYYY: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 9999,
            placeholderChar: "Y",
          },
        },
        format: (date) => {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          const year = date.getFullYear();

          if (day < 10) day = "0" + day;
          if (month < 10) month = "0" + month;

          return [month, day, year].join("/");
        },
        parse: (str) => {
          const yearMonthDay = str.split("/");
          return new Date(yearMonthDay[2], yearMonthDay[0] - 1, yearMonthDay[1]);
        },
      });

      mask.on("accept", () => {
        if (mask.value === pattern) {
          field.classList.remove("is-filled");
          field.classList.remove("has-value");
        } else {
          field.classList.add("has-value");
        }
      });
      mask.on("complete", () => field.classList.add("is-filled"));

      field.addEventListener("changeDate", () => {
        mask.updateValue();
      });
    }
  });
};

const setupSpecialFields = (form) => {
  form.querySelectorAll("input[type=file]").forEach((input) => {
    const placeholder = document.createElement("div");
    placeholder.classList.add("file-input-placeholder");

    if (input.value) {
      placeholder.textContent = input.files[0].name;
    } else {
      placeholder.textContent = input.dataset.placeholder;
    }

    input.parentNode.insertBefore(placeholder, input);

    placeholder.addEventListener("click", () => input.click());

    input.addEventListener("change", (e) => {
      placeholder.textContent = e.target.files[0].name;
      placeholder.classList.add("filled");
    });
  });
};

export const setupStyledForm = (form) => {
  setupDropdowns(form);
  setupMasks(form);
  setupSpecialFields(form);
};
